import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Grid,
  Card,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Alert,
  Tooltip,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Colors from "../../utility/Colors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { background_orange_gradient } from "../../assets/jss/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  getCaseThunk,
  getActivityDetailsThunk,
  saveOrUpdateActivityDetailsThunk,
} from "./reducer/thunk";
import { useDispatch, useSelector } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import constants, {
  File_Validation,
  File_MAX_SIZE,
} from "../../common/constants.js";
import FileUploadModal from "./fileUploadModal.tsx";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CommentIcon from "@mui/icons-material/Comment";
import RefreshIcon from "@mui/icons-material/Refresh";
import SendIcon from "@mui/icons-material/Send";
import Methods from "../../utility/Methods.js";
import DepartmentSelectionModal from "./DepartmentSelectionModal.js";
import Backdrop from "../../components/backdrop/index.tsx";
import FileSaver from "file-saver";
import { getSession } from "../../utility/SessionManager.js";
import {
  columnMenuStateInitializer,
  columnsStateInitializer,
} from "@mui/x-data-grid/internals";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import CloseIcon from "@mui/icons-material/Close";
import {
  closeOrReOpenCaseThunk,
  saveOrUpdateCaseThunk,
} from "../AddNewReward/reducer/thunk.js";
import ClosedFormDetailsModal from "./closedFormDetails.js";
import { getLocalDateTime } from "../../utility/common-functions.js";
import { resetSaveOrUpdateActivityDetails } from "./reducer/slice.js";

const ViewDetails = (props) => {
  const location = useLocation();
  const { id } = location.state || {};
  const role = Methods.getRole();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [value, setValue] = React.useState("1");
  const [files, setFiles] = useState();
  const [getCaseDetails, setGetCaseDetails] = useState(null);
  const [latestAssigneeArr, setLatestAssigneeArr] = useState([]);
  const [latestSenderRole, setLatestSenderRole] = useState("");
  const [getActivityDetailsArr, setGetActivityDetailsArr] = useState([]);
  const [addComment, setAddComment] = useState("");
  const [fileUploadModalOpen, setFileUploadModalOpen] = useState(false);
  const [openCloseModal, setOpenCloseModal] = useState(false);
  const [fileValidationErr, setFileValidationErr] = useState({
    file_size: false,
    file_type: false,
  });
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });
  const [departmentSelectionModalOpen, setDepartmentSelectionModalOpen] =
    useState(false);
  const [showButtonsAsPerRole, setShowButtonsAsPerRole] = useState([]);
  const [closeDetails, setCloseDetails] = useState({
    id: "",
    role: "",
    isClosed: false,
  });

  const getCase = useSelector((state) => state.getCase.getCase);
  const getActivityDetails = useSelector(
    (state) => state.getCase.getActivityDetails
  );
  const saveOrUpdateActivityDetails = useSelector(
    (state) => state.getCase.saveOrUpdateActivityDetails
  );

  const closeOrReOpenCase = useSelector(
    (state) => state.finalStatusList.closeOrReOpenCase
  );

  const {
    status: getCaseStatus,
    data: getCaseData,
    error: getCaseError,
  } = getCase;
  const {
    status: getActivityDetailsStatus,
    data: getActivityDetailsData,
    error: getActivityDetailsError,
  } = getActivityDetails;
  const {
    status: saveOrUpdateActivityDetailsStatus,
    data: saveOrUpdateActivityDetailsData,
    error: saveOrUpdateActivityDetailsError,
  } = saveOrUpdateActivityDetails;
  const {
    status: closeOrReOpenCaseStatus,
    data: closeOrReOpenCaseData,
    error: closeOrReOpenCaseError,
  } = closeOrReOpenCase;

  useEffect(() => {
    dispatch(getCaseThunk({ caseId: id }));
    dispatch(getActivityDetailsThunk({ caseId: id }));
  }, [id, saveOrUpdateActivityDetailsStatus, closeOrReOpenCaseStatus]);

  useEffect(() => {
    if (saveOrUpdateActivityDetailsStatus === "succeeded") {
      handleShowSnackbar("success", "Details updated successfully");
    } else if (saveOrUpdateActivityDetailsStatus === "failed") {
      handleShowSnackbar(
        "error",
        saveOrUpdateActivityDetailsError?.error?.errorMessage
          ? saveOrUpdateActivityDetailsError?.error?.errorMessage
          : "An error occured!"
      );
      setFiles([]);
    }
  }, [saveOrUpdateActivityDetailsStatus]);

  useEffect(() => {
    return () => {
      dispatch(resetSaveOrUpdateActivityDetails());
    };
  }, []);

  useEffect(() => {
    if (role) {
      let allowedArr = [];
      if (role === constants.CASE_OWNER) {
        allowedArr.push(constants.LEGAL_MANAGER);
      } else if (role === constants.LEGAL_MANAGER) {
        allowedArr.push(constants.CASE_OWNER, constants.HOD, constants.CHECKER);
      } else if (role === constants.HOD) {
        allowedArr.push(constants.LEGAL_MANAGER);
      } else if (role === constants.CHECKER) {
        allowedArr.push(
          constants.LEGAL_MANAGER,
          constants.GRIEVANCE,
          constants.CLAIMS,
          constants.OPERATIONS,
          constants.UNDERWRITING
        );
      } else if (
        role === constants.GRIEVANCE ||
        constants.CLAIMS ||
        constants.OPERATIONS ||
        constants.UNDERWRITING
      ) {
        allowedArr.push(
          constants.CHECKER,
          constants.GRIEVANCE,
          constants.CLAIMS,
          constants.OPERATIONS,
          constants.UNDERWRITING
        );
      }
      setShowButtonsAsPerRole(allowedArr);
    }
  }, [role]);

  useEffect(() => {
    if (getCaseStatus === "succeeded") {
      let tempObj = { ...getCaseData };

      !tempObj.caseStatus && delete tempObj.caseStatus;
      setGetCaseDetails(tempObj);
      setLatestAssigneeArr(tempObj.latestAssignees);
    }
  }, [getCaseData]);

  useEffect(() => {
    if (getActivityDetailsStatus === "succeeded") {
      const listData = getActivityDetailsData || [];
      setGetActivityDetailsArr(listData);
      setLatestSenderRole(listData[0]?.senderRole);
    }
  }, [getActivityDetailsData]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleFileUpload = (e) => {
    console.log("Files....", e.target.files);
    let latestFiles = Array.from(e.target.files);
    let totalFiles = files ? files.concat(latestFiles) : latestFiles;
    if (totalFiles.length > 5) {
      totalFiles = totalFiles.slice(0, 5);
    }

    // File size validation (15mb = 5 * 1024 * 1024 bytes)
    // const maxFileSize = constants.File_MAX_SIZE;
    const maxFileSize = 15 * 1024 * 1024;
    const oversizedFiles = totalFiles.filter((file) => file.size > maxFileSize);
    const totalSize = totalFiles.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > 20 * 1024 * 1024) {
      // Set validation error for file size
      setFileValidationErr({
        ...fileValidationErr,
        file_size: true,
      });
      // Don't set the files if any are oversized
      return;
    }
    if (oversizedFiles.length > 0) {
      // Set validation error for file size
      setFileValidationErr({
        ...fileValidationErr,
        file_size: true,
      });

      // Don't set the files if any are oversized
      return;
    } else {
      // Clear validation errors if all files are valid
      setFileValidationErr({
        file_size: false,
        file_type: false,
      });
    }

    setFiles(totalFiles);
    //  Reset the input value so the same file can be selected again
    e.target.value = null;
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleSnackClose = () => {
    setSnackbarOpen({
      open: "",
      severity: "",
      message: "",
    });
  };

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity: severity,
      message: message,
    });
  };
  const getAuthToken = () => {
    return Methods.decrypt(
      getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)
    );
  };

  const handleFileDownload = (e, fileName, fileUrl) => {
    console.log(`Downloading file: ${fileName} from ${fileUrl}`);
    fetch(fileUrl, {
      headers: { Authorization: `Bearer ${getAuthToken()}` },
    })
      .then((res) => res.blob())
      .then((blob) => {
        const file = new Blob([blob]);
        FileSaver.saveAs(file, fileName);
      })
      .catch((error) => {
        console.error("downloadFile error: ", error);
      });
  };

  const checkIfDateOrArray = (value) => {
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
    if (typeof value === "string" && isoDateRegex.test(value)) {
      return new Date(value).toLocaleDateString();
    } else if (Array.isArray(value)) {
      return value.join(", ");
    } else {
      return value;
    }
  };

  const showSendToCaseOwnerToManagerRole = () => {
    let createdByRole = getCaseData?.createdByRole;
    if (createdByRole === constants.CASE_OWNER) {
      return true;
    } else {
      return false;
    }
  };

  const handleSendComment = async () => {
    const updateDetailsData = new FormData();
    updateDetailsData.append("caseId", id);
    addComment && updateDetailsData.append("senderComment", addComment);
    role && updateDetailsData.append("reviewerRole", role);

    dispatch(saveOrUpdateActivityDetailsThunk(updateDetailsData));
  };

  const handleAction = ({ passRole = "", isReopen = false } = {}) => {
    const updateDetailsData = new FormData();
    updateDetailsData.append("caseId", id);
    if (isReopen) {
      passRole && updateDetailsData.append("reviewerRole", passRole);
      updateDetailsData.append("isReopen", isReopen);
      dispatch(saveOrUpdateActivityDetailsThunk(updateDetailsData));
      handleCaseCloseOReOpen({
        passRole: role,
        caseStatus: constants.REOPENED,
      });
    } else {
      addComment && updateDetailsData.append("senderComment", addComment);
      passRole && updateDetailsData.append("reviewerRole", passRole);
      files && files[0] && updateDetailsData.append("file", files[0]);
      files && files[1] && updateDetailsData.append("file", files[1]);
      files && files[2] && updateDetailsData.append("file", files[2]);
      files && files[3] && updateDetailsData.append("file", files[3]);
      files && files[4] && updateDetailsData.append("file", files[4]);

      dispatch(saveOrUpdateActivityDetailsThunk(updateDetailsData));
    }
    setFiles([]);
    setAddComment("");
  };

  const handleCaseCloseOReOpen = async ({
    passRole = "",
    caseStatus,
    closingValues = "",
  } = {}) => {
    let data = getCaseData;
    const updateDetailsData = {
      caseNumber: data?.caseNumber,
      caseId: data?.caseId,
      complainantName: data?.complainantName,
      caseStatus: caseStatus,
      paidClaimAmount: closingValues?.paidClaimAmount,
      cost: closingValues?.cost,
      paidInterestAmount: closingValues?.paidInterestAmount,
      dateOfComplianceOrder: getLocalDateTime(
        new Date(closingValues?.dateOfCompliance)
      ),
    };
    //api call for file upload
    dispatch(closeOrReOpenCaseThunk(updateDetailsData));
  };

  const handleClose = ({ passRole = "" } = {}) => {
    const updateDetailsData = new FormData();
    updateDetailsData.append("caseId", id);

    addComment && updateDetailsData.append("senderComment", addComment);
    passRole && updateDetailsData.append("reviewerRole", passRole);
    files && files[0] && updateDetailsData.append("file", files[0]);
    files && files[1] && updateDetailsData.append("file", files[1]);
    files && files[2] && updateDetailsData.append("file", files[2]);
    files && files[3] && updateDetailsData.append("file", files[3]);
    files && files[4] && updateDetailsData.append("file", files[4]);

    dispatch(saveOrUpdateActivityDetailsThunk(updateDetailsData));
    setFiles([]);
    setAddComment("");
  };

  const departmentSelectionModalHandler = () => {
    setDepartmentSelectionModalOpen(false);
  };

  const handleSubmitDepartment = async (val) => {
    const updateDetailsData = new FormData();
    updateDetailsData.append("caseId", id);
    addComment && updateDetailsData.append("senderComment", addComment);
    val && updateDetailsData.append("reviewerRole", val);
    files && files[0] && updateDetailsData.append("file", files[0]);
    files && files[1] && updateDetailsData.append("file", files[1]);
    files && files[2] && updateDetailsData.append("file", files[2]);
    files && files[3] && updateDetailsData.append("file", files[3]);
    files && files[4] && updateDetailsData.append("file", files[4]);
    dispatch(saveOrUpdateActivityDetailsThunk(updateDetailsData));
    setFiles([]);
    setAddComment("");
    setDepartmentSelectionModalOpen(false);
  };

  const disableAction = (btnName) => {
    if (
      saveOrUpdateActivityDetailsStatus === "pending" ||
      fileValidationErr.file_size ||
      fileValidationErr.file_type
    ) {
      return true;
    } else if (
      (latestAssigneeArr !== null && latestAssigneeArr?.includes(role)) ||
      !latestAssigneeArr
    ) {
      //if latest assignee array is not empty and role is same
      if (
        latestAssigneeArr !== null &&
        latestAssigneeArr?.includes(btnName) &&
        latestSenderRole === role
      ) {
        // if last sender is same allow user to add more comments
        return false;
      } else if (
        latestAssigneeArr !== null &&
        latestAssigneeArr?.includes(role)
      ) {
        // if role is same as last assigned allow uuser all buttons
        return false;
      } else {
        // disable other buttons
        return true;
      }
    } else {
      //if user has logged in with diff role (unassigned user) and last sender should be also same
      if (latestAssigneeArr?.includes(btnName) && latestSenderRole === role) {
        return false;
      } else {
        return true;
      }
    }
  };

  const disableActionForDepartments = (btnName) => {
    let departmentsRoles = [
      constants.OPERATIONS,
      constants.CLAIMS,
      constants.GRIEVANCE,
      constants.UNDERWRITING,
    ];
    if (
      saveOrUpdateActivityDetailsStatus === "pending" ||
      fileValidationErr.file_size ||
      fileValidationErr.file_type
    ) {
      return true;
    } else if (
      latestAssigneeArr !== null &&
      latestAssigneeArr?.includes(role)
    ) {
      return false;
    } else if (latestAssigneeArr?.includes(constants.CHECKER)) {
      //this keeps button enabled for last sender if he is current user
      return true;
    } else {
      return true;
    }
  };

  const disableActionForChecker = (btnName) => {
    if (
      saveOrUpdateActivityDetailsStatus === "pending" ||
      fileValidationErr?.file_size ||
      fileValidationErr?.file_type
    ) {
      return true;
    } else if (
      latestAssigneeArr !== null &&
      latestAssigneeArr?.includes(role)
    ) {
      return false;
    } else if (
      role === constants.LEGAL_MANAGER &&
      latestAssigneeArr?.includes(constants.LEGAL_MANAGER)
    ) {
      //checking if role is manager and lastest assignee is also manager then allow button
      return false;
    } else {
      return true;
    }
  };

  const disableActionForCloseCase = () => {
    if (
      saveOrUpdateActivityDetailsStatus === "pending" ||
      fileValidationErr.file_size ||
      fileValidationErr.file_type
    ) {
      return true;
    } else if (
      latestAssigneeArr !== null &&
      latestAssigneeArr?.includes(constants.CHECKER)
    ) {
      return false;
    } else if (getCaseDetails?.caseStatus === constants.REOPENED) {
      return false;
    } else {
      return true;
    }
  };

  const handleCloseCase = (closingValues) => {
    const { id, role, isClosed } = closeDetails;
    const updateDetailsData = new FormData();
    id && updateDetailsData.append("caseId", id);
    role && updateDetailsData.append("reviewerRole", role);
    isClosed && updateDetailsData.append("isClosed", isClosed);

    dispatch(saveOrUpdateActivityDetailsThunk(updateDetailsData));
    handleCaseCloseOReOpen({
      passRole: constants.CHECKER,
      caseStatus: constants.CLOSED,
      closingValues: closingValues,
    });
    setOpenCloseModal(false);
  };

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "fullWidth",
          minHeight: "100vh",
          marginTop: "10px",

          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {/* {getActivityDetailsStatus === "pending" ? <Backdrop /> : null} */}
        {saveOrUpdateActivityDetailsStatus === "pending" ? <Backdrop /> : null}
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab
                label={
                  getCaseDetails
                    ? `Case Id: ${getCaseDetails?.caseId}`
                    : "Case Details"
                }
                value="1"
              />
            </TabList>
          </Box>
        </TabContext>
        {[constants.CHECKER, constants.LEGAL_MANAGER].includes(role) &&
        [constants.ACTIVE, constants.CLOSED].includes(
          getCaseDetails?.caseStatus
        ) ? (
          <Grid container sx={{ placeContent: "space-between" }}>
            {" "}
            <Grid>
              <Typography
                // variant="body2"
                sx={{
                  color: " #60666F",
                  py: 1,
                  fontSize: " 14px",
                  fontStyle: " normal",
                  fontWeight: " 500",
                  lineHeight: " normal",
                  textAlign: "left",
                }}
              >
                Award Details
              </Typography>
            </Grid>
            {/* <Grid>
              <Button
                fullWidth
                onClick={() => {
                  handleAction({ passRole: role, isReopen: true });
                }}
                sx={{
                  pt: 1,
                  pb: 1,
                  borderRadius: "10px",
                  background: "rgb(245, 132, 31)",
                }}
                variant="contained"
              >
                ReOpen
              </Button>
            </Grid> */}
          </Grid>
        ) : (
          <Typography
            // variant="body2"
            sx={{
              color: " #60666F",
              py: 1,
              fontSize: " 14px",
              fontStyle: " normal",
              fontWeight: " 500",
              lineHeight: " normal",
              textAlign: "left",
            }}
          >
            Award Details
          </Typography>
        )}
        {getCaseDetails !== null ? (
          <Card
            sx={{
              width: "fullWidth",
              marginTop: "10px",
              borderRadius: "10px",
              background: "#FEF8F2",
              p: 1,
              px: 4,
              // pl: 15,
              pb: 2,
              mb: 2,
              boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
            }}
          >
            <Grid
              container
              size={{ xs: 12, md: 12 }}
              justifyContent={"space-between"}
            >
              {getCaseDetails &&
                Object.keys(getCaseDetails).length > 0 &&
                Object.entries(getCaseDetails).map(([key, value]) => {
                  return key === "caseId" ||
                    key === "createdBy" ||
                    key === "createdByRole" ? (
                    <></>
                  ) : (
                    <>
                      <Grid
                        item
                        key={key}
                        size={{ xs: 2, md: 2 }}
                        sx={{
                          my: 1,
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            color: " #60666F",
                            py: 1,
                            fontSize: " 14px",
                            fontStyle: " normal",
                            fontWeight: " 500",
                            lineHeight: " normal",
                            textAlign: "left",
                          }}
                        >
                          {key
                            .replace(/([a-z])([A-Z])/g, "$1 $2")
                            .replace(/^./, function (match) {
                              return match.toUpperCase();
                            })}
                        </Typography>{" "}
                        <Typography
                          // noWrap
                          sx={{
                            color: " #000",
                            fontSize: " 15px",
                            fontStyle: " normal",
                            fontWeight: " 700",
                            lineHeight: " normal",
                            textAlign: "left",
                          }}
                        >
                          {checkIfDateOrArray(value)
                            ? checkIfDateOrArray(value)
                            : "-"}
                        </Typography>{" "}
                      </Grid>
                    </>
                  );
                })}
            </Grid>
          </Card>
        ) : (
          <Card
            sx={{
              width: "fullWidth",
              marginTop: "10px",
              borderRadius: "10px",
              background: "#FEF8F2",
              p: 2,
              boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
            }}
          >
            <Grid
              container
              size={{ xs: 12, md: 12 }}
              justifyContent={"space-between"}
            >
              <Typography variant="body2">
                Failed to load Award details..!
              </Typography>{" "}
            </Grid>
          </Card>
        )}
        <Typography
          // variant="body2"
          sx={{
            color: " #60666F",
            py: 1,
            fontSize: " 14px",
            fontStyle: " normal",
            fontWeight: " 500",
            lineHeight: " normal",
            textAlign: "left",
          }}
        >
          Activity History
        </Typography>{" "}
        <Card
          sx={{
            width: "fullWidth",
            marginTop: "10px",
            borderRadius: "10px",
            background: "#FEF8F2",
            p: 2,
            boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          }}
        >
          <Grid container spacing={2} alignItems="flex-start">
            {/* Comment Box */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth sx={{ m: 2 }}>
                <InputLabel size="small" htmlFor="outlined-comment">
                  Add Comment
                </InputLabel>
                <OutlinedInput
                  id="outlined-comment"
                  label="Add Comment"
                  size="small"
                  multiline
                  minRows={3}
                  maxRows={3}
                  inputProps={{
                    style: {
                      overflow: "auto",
                    },
                  }}
                  sx={{
                    borderRadius: "10px",
                  }}
                  placeholder="Add Comment"
                  onChange={(e) => setAddComment(e.target.value)}
                  value={addComment}
                  // endAdornment={
                  //   <InputAdornment position="end">
                  //     <IconButton
                  //       aria-label="Add comment"
                  //       edge="end"
                  //       disabled={addComment === ""}
                  //       onClick={() => handleSendComment()}
                  //     >
                  //       <SendIcon />
                  //     </IconButton>
                  //   </InputAdornment>
                  // }
                />
              </FormControl>
            </Grid>

            {/* Buttons */}
            <Grid item xs={12} md={8}>
              <Grid container spacing={2} sx={{ m: 2 }}>
                {/* Upload Icon */}
                <Grid item xs={12} sm={6} md={3}>
                  <input
                    id="file-input"
                    type="file"
                    accept="image/jpeg,image/png,application/pdf"
                    name="files[]"
                    multiple
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    style={{
                      display: "none",
                    }}
                  />
                  <Button
                    type="file"
                    // onChange={handleFileUpload}
                    onClick={handleClick}
                    sx={{
                      pt: 1,
                      pb: 1,
                      borderRadius: "10px",
                    }}
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                  >
                    Select File
                  </Button>
                  <br />
                  {/* File validation error display */}
                  {fileValidationErr.file_size && (
                    <Alert severity="error" sx={{ mt: 1, mb: 1 }}>
                      Each file must be under 15MB, and total upload size must
                      not exceed 20MB.
                    </Alert>
                  )}

                  {files && files.length > 0 ? (
                    <span>
                      Selected Files:{" "}
                      {Object.keys(files).map((val) => {
                        return (
                          <span
                            key={val}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{ overflowWrap: "break-word" }}
                            >
                              {files[val]?.name} (
                              {(files[val]?.size / (1024 * 1024)).toFixed(2)}{" "}
                              MB)
                            </Typography>
                            <IconButton
                              size="small"
                              aria-label="Remove file"
                              onClick={() => {
                                const newFiles = files.filter(
                                  (_, idx) => idx !== Number(val)
                                );
                                console.log("newFiles", files);
                                setFiles(newFiles);
                              }}
                            >
                              <Tooltip title="Remove File">
                                <CloseIcon color="error" />
                              </Tooltip>
                            </IconButton>
                          </span>
                        );
                      })}
                    </span>
                  ) : null}

                  {/* File size limit information */}
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ display: "block", mt: 1 }}
                  >
                    Maximum file size: 15mb per file
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ display: "block", mt: 1 }}
                  >
                    Total Maximum file size: 20MB (All files)
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ display: "block", mt: 1 }}
                  >
                    Maximum file count: 5 Files
                  </Typography>
                </Grid>
                {/* send to case owner */}
                {showButtonsAsPerRole.includes(constants.CASE_OWNER) &&
                showSendToCaseOwnerToManagerRole() ? (
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      onClick={() => {
                        handleAction({ passRole: constants.CASE_OWNER });
                      }}
                      sx={{
                        pt: 1,
                        pb: 1,
                        borderRadius: "10px",
                        background: "rgb(245, 132, 31)",
                        display: showButtonsAsPerRole.includes(
                          constants.CASE_OWNER
                        )
                          ? null
                          : "none",
                      }}
                      variant="contained"
                      disabled={disableAction(constants.CASE_OWNER)}
                    >
                      Send to Case Owner
                    </Button>
                  </Grid>
                ) : null}
                {/* send to Manager */}
                {showButtonsAsPerRole.includes(constants.LEGAL_MANAGER) && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      onClick={() => {
                        handleAction({ passRole: constants.LEGAL_MANAGER });
                      }}
                      sx={{
                        pt: 1,
                        pb: 1,
                        borderRadius: "10px",
                        background: "rgb(245, 132, 31)",
                        display: showButtonsAsPerRole.includes(
                          constants.LEGAL_MANAGER
                        )
                          ? null
                          : "none",
                      }}
                      variant="contained"
                      disabled={disableAction(constants.LEGAL_MANAGER)}
                    >
                      Send to Manager
                    </Button>
                  </Grid>
                )}
                {/* send to HOD */}
                {showButtonsAsPerRole.includes(constants.HOD) && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      onClick={() => {
                        handleAction({ passRole: constants.HOD });
                      }}
                      sx={{
                        pt: 1,
                        pb: 1,
                        borderRadius: "10px",
                        background: "rgb(245, 132, 31)",
                        display: showButtonsAsPerRole.includes(constants.HOD)
                          ? null
                          : "none",
                      }}
                      variant="contained"
                      disabled={disableAction(constants.HOD)}
                    >
                      Send to HOD
                    </Button>
                  </Grid>
                )}
                {/* send to Checker */}
                {showButtonsAsPerRole.includes(
                  constants.CHECKER ||
                    constants.OPERATIONS ||
                    constants.CLAIMS ||
                    constants.GRIEVANCE ||
                    constants.UNDERWRITING
                ) && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      onClick={() => {
                        handleAction({ passRole: constants.CHECKER });
                      }}
                      sx={{
                        pt: 1,
                        pb: 1,
                        borderRadius: "10px",
                        background: "rgb(245, 132, 31)",
                        display: showButtonsAsPerRole.includes(
                          constants.CHECKER
                        )
                          ? null
                          : "none",
                      }}
                      variant="contained"
                      disabled={disableActionForChecker(constants.CHECKER)}
                    >
                      Send to Checker
                    </Button>
                  </Grid>
                )}
                {/* send to Departments */}
                {showButtonsAsPerRole.includes(
                  constants.OPERATIONS ||
                    constants.CLAIMS ||
                    constants.GRIEVANCE ||
                    constants.UNDERWRITING
                ) && (
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      onClick={() => {
                        setDepartmentSelectionModalOpen(true);
                      }}
                      sx={{
                        pt: 1,
                        pb: 1,
                        borderRadius: "10px",
                        background: "rgb(245, 132, 31)",
                        display: showButtonsAsPerRole.includes(
                          constants.OPERATIONS ||
                            constants.CLAIMS ||
                            constants.GRIEVANCE ||
                            constants.UNDERWRITING
                        )
                          ? null
                          : "none",
                      }}
                      variant="contained"
                      disabled={disableActionForDepartments(
                        constants.OPERATIONS
                      )}
                    >
                      Send to Departments
                    </Button>
                  </Grid>
                )}
                {/* case Close*/}
                {role === constants.CHECKER &&
                  constants.CLOSED !== getCaseDetails?.caseStatus && (
                    <Grid item xs={12} sm={6} md={3}>
                      <Button
                        fullWidth
                        onClick={() => {
                          setCloseDetails({
                            id: id,
                            role: role,
                            isClosed: true,
                          });
                          setOpenCloseModal(true);
                        }}
                        sx={{
                          pt: 1,
                          pb: 1,
                          borderRadius: "10px",
                          background: "rgb(245, 132, 31)",
                        }}
                        variant="contained"
                        disabled={disableActionForCloseCase()}
                      >
                        Close case
                      </Button>
                    </Grid>
                  )}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            xs={12}
            md={12}
            sx={{
              m: 2,
            }}
          >
            <Stepper
              activeStep={getActivityDetailsArr?.length}
              orientation="vertical"
            >
              {getActivityDetailsArr?.map((activity) => (
                <Step active={true} key={activity.activityId}>
                  <StepLabel
                    icon={
                      activity.fileUrl ? (
                        <CloudUploadIcon color="primary" />
                      ) : activity.senderComment ? (
                        <CommentIcon color="secondary" />
                      ) : (
                        <CheckCircleIcon color="success" />
                      )
                    }
                    optional={
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {`${activity.senderName} (${activity.senderRole.replace(
                          "_",
                          " "
                        )})`}
                      </Typography>
                    }
                  >
                    {new Date(activity.created).toLocaleString()}
                  </StepLabel>

                  <StepContent>
                    {(activity.isClosed || activity.senderComment) && (
                      <Typography>
                        {activity.isClosed
                          ? `Case closed by ${
                              activity.senderName
                            } (${activity.senderRole.replace("_", " ")})`
                          : activity.senderComment}
                      </Typography>
                    )}
                    {activity.reviewerRole && (
                      <Typography>{`Assigned to: ${
                        activity.reviewerName
                      } (${activity.reviewerRole.replace(
                        "_",
                        " "
                      )})`}</Typography>
                    )}
                    {activity.activityFileLogList &&
                      activity.activityFileLogList[0] &&
                      activity.activityFileLogList[0].fileName &&
                      activity.activityFileLogList?.map((activityFile) => {
                        return (
                          <>
                            <Typography
                              sx={{
                                display: "inline-flex",
                              }}
                            >
                              Uploaded file:{" "}
                              {
                                <a
                                  style={{
                                    marginLeft: "10px",
                                    color: "#0063AA",
                                    display: "inline-flex",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) =>
                                    handleFileDownload(
                                      e,
                                      activityFile.fileName,
                                      activityFile.fileUrl
                                    )
                                  }
                                >
                                  {activityFile.fileName}
                                </a>
                              }
                            </Typography>
                            <br />
                          </>
                        );
                      })}
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Grid>
        </Card>
        {departmentSelectionModalOpen && (
          <DepartmentSelectionModal
            departmentSelectionModalOpen={departmentSelectionModalHandler}
            handleSubmitDepartment={handleSubmitDepartment}
            closeModal={() => setDepartmentSelectionModalOpen(false)}
            currentDepartment={role}
          />
        )}
        {
          <SnackbarComponent
            message={snackbarOpen?.message}
            isOpen={snackbarOpen?.open}
            purpose={snackbarOpen?.severity}
            handleClick={handleSnackClose}
          />
        }
        {openCloseModal && (
          <ClosedFormDetailsModal
            open={openCloseModal}
            handleClose={() => setOpenCloseModal(false)}
            submitClickHandler={handleCloseCase}
          />
        )}
      </Card>
    </div>
  );
};

export default ViewDetails;
